import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { GetFileSizePipe } from '../../../../pipes/get-file-size.pipe';
import { ButtonComponent } from '../../../buttons/button/button.component';
import { ButtonType } from '../../../enum/button-type.enum';
import { InputSize } from '../../../enum/input-size.enum';
import { MatIcon } from '@angular/material/icon';
import { FormErrorComponent } from '../../form-error/form-error.component';

@Component({
  selector: 'lib-file-list-item',
  imports: [GetFileSizePipe, ButtonComponent, MatIcon, FormErrorComponent],
  templateUrl: './file-list-item.component.html',
  styleUrl: './file-list-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileListItemComponent {
  file = input.required<File>();
  validationErrors = input<ValidationErrors | null>();
  hideView = input<boolean>(false);
  hideDelete = input<boolean>(false);
  hideReplace = input<boolean>(false);
  disabled = input<boolean>(false);
  thumbnail = input<boolean>(false);
  readonly hasErrors = computed(() => !!this.validationErrors());
  previewClicked = output<File>();
  removeClicked = output<File>();
  replaceClicked = output<File>();

  protected readonly ButtonType = ButtonType;
  protected readonly InputSize = InputSize;
  protected readonly URL = URL;
}
